import { Component } from "vue";



export class WizardStepAvailabiltyModel {

    constructor(public isAvailable: boolean,
        public unavailableComponent?: Component,
        public lockStepOnUnavailable?: boolean
    ) {

    }

}